import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=90bd44be&"
import script from "./CardDetails.vue?vue&type=script&lang=js&"
export * from "./CardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports